import cx from 'classnames'
import { m } from 'framer-motion'

import styles from './progressBar.module.scss'

type ProgressBarProps = {
  progressPercentage: number
  completed?: boolean
}

export const ProgressBar = ({ progressPercentage, completed }: ProgressBarProps) => {
  return (
    <div className={styles.progressBarContainer}>
      <div className={cx(styles.progressBar, { [styles.completed]: completed })}>
        <m.div
          initial={{ width: 0 }}
          animate={{ width: `${progressPercentage}%` }}
          className={styles.progressBarFill}
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </div>
  )
}
